<template>
  <div>
    <el-button @click="open" type="primary">批量复制尺寸</el-button>
    <el-dialog title="选择批次包" :visible.sync="dialogVisible" width="800px" @close="cancel" :before-close="beforeClose">
      <div>
        <div>
          <el-input v-model="code" placeholder="扫商品批次包" @keydown.native.enter="search" ref="codeInput"></el-input>
        </div>
        <div style="margin: 10px 0;text-align: left;display: flex;justify-content: space-between;">
          <span>
            已选择{{ dataSource.length }}个批次包
          </span>
          <div>
            <el-button type="primary" @click="submit">确 定</el-button>
          </div>
        </div>
        <div>
          <el-table :data="dataSource" border style="width:100%">
            <el-table-column label="批次包编码" prop="pkgCode">
            </el-table-column>
            <el-table-column label="商品SKU" prop="productSku">
            </el-table-column>
            <el-table-column label="商品名称" prop="productName">
            </el-table-column>
            <el-table-column label="商品图片" prop="ingredientsName">
              <template slot-scope="scope">
                <img :src="scope.row.productImg" alt="" style="height: 60px;">
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="ingredientsName">
              <template slot-scope="scope">
                <a @click="del(scope.row)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeClose(cancel)">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { pkgDetail } from "@/apis/abnormal";
import { batchEditSizeApi } from '@/apis/inHouse'
export default {
  name: 'batch-copy-size',
  props: {
    sizeList: {
      type: Array,
      default: () => []
    },
    productSku: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    checkSize: {
      type: Function | undefined,
      default: undefined
    }
  },
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      code: '',
      dataSource: [],
      loading: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.focus()
      }
    }
  },
  methods: {
    beforeClose(done) {
      if (this.dataSource.length) {
        this.$confirm('是否关闭弹窗', "提示", {
          confirmButtonText: "确认",
          type: "error",
          cancelButtonText: "取消",
        }).then(() => {
          done()
        });
      } else {
        done()
      }
    },
    cancel() {
      this.dialogVisible = false
      this.dataSource = []
      this.code = ''
    },
    focus() {
      setTimeout(() => {
        this.$refs.codeInput?.focus()
      }, 100)
    },
    submit() {
      if (!this.dataSource.length) {
        this.$message.warning('请扫描商品批次号')
        return
      }
      batchEditSizeApi({
        list: this.sizeList.filter(v => v.value).map(v => {
          return {
            ...v,
            value: v.value
          }
        }),
        pkgCodeList: this.dataSource.map(v => v.pkgCode),
        measureCategory: this.category === 'all' ? '' : this.category
      }).then(({code}) => {
        if(code === 0) {
          this.$message.success('操作成功')
          this.cancel()
        }
      })
    },
    search() {
      if (!this.code) {
        this.$message.warning('请扫描商品批次号')
        return
      }
      if (this.dataSource.some(v => v.pkgCode === this.code)) {
        this.$message.warning('该批次包已存在列表中')
        return
      }
      if(this.loading) return
      this.loading = true
      pkgDetail({
        pkgCode: this.code
      }).then(({ code, data }) => {
        if (code === 0) {
          if (this.dataSource.some(v => v.productSku !== data.productSku)) {
            this.$message.warning('当前选中的批次包与复制尺寸的批次包商品不一致，请确认')
          } else {
            this.dataSource.unshift(data)
          }
        }
        this.code = ''
        this.focus()
      }).finally(() => {
        this.loading = false
      })
    },
    open() {
      console.log(this.sizeList)
      if(this.checkSize) {
        const isTrue = this.checkSize()
        if(!isTrue) return
      } else {
        if (this.sizeList.every(v => !v.value)) {
          this.$message.warning('请先填写尺码')
          return
        }
        if (this.sizeList.some(v => isNaN(v.value))) {
          this.$message.warning('尺寸必须是数字')
          return false
        }
        if (this.sizeList.some(v => v.value && Number(v.value) == 0)) {
          this.$message.warning('尺寸不能为0')
          return false
        }
        if (this.sizeList.some(v => v.value && Number(v.value) < 0)) {
          this.$message.warning('尺寸不能为负数')
          return false
        }

      }
      this.dialogVisible = true
      this.dataSource = [this.item]
    },
    del(row) {
      this.dataSource = this.dataSource.filter(v => v.pkgCode !== row.pkgCode)
      this.focus()
    }
  }
}
</script>
